const INVALID_DBA_VALUES = [
  'n/a',
  'na',
  'n a',
  'none',
  'same',
  'self',
  'same as business name',
  'same as above',
  'not applicable',
  '---',
  '###',
  'dba same',
  'n/a dba',
  'individual',
  'owner',
  'no dba',
  'no',
  'blank'
];

function normalizeString(value: string): string {
  return value.toLowerCase().trim().replace(/\s+/g, ' ');
}

export function isInvalidDba(dbaValue: string | null | undefined): boolean {
  if (!dbaValue || dbaValue.trim() === '') {
    return false;
  }

  const normalized = normalizeString(dbaValue);

  return INVALID_DBA_VALUES.some((invalidValue) => {
    const normalizedInvalid = normalizeString(invalidValue);
    return normalized === normalizedInvalid;
  });
}

export const DBA_VALIDATION_ERROR_MESSAGE =
  'DBA not valid since invoices may be paid in the DBA name. Please enter a valid DBA or leave this field blank.';
